module.exports = __webpack_public_path__ + "static/img/light.d0efa020.svg";